// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".le-pagination{padding:15px 10px}.le-pagination .buttons{width:100%}\n", "",{"version":3,"sources":["webpack://./src/components/partials/Pagination.vue"],"names":[],"mappings":"AACA,eACE,iBAAiB,CADnB,wBAGI,UAAW","sourcesContent":["\n.le-pagination{\n  padding:15px 10px;\n  .buttons{\n    width: 100%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
